if (!customElements.get('product-duo')) {
  customElements.define(
    'product-duo',
    class ProductDuo extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.product-duo__button');
        this.error = this.querySelector('.product-duo__error');
        this.button?.addEventListener('click', this.addBoth.bind(this));
      }

      async addBoth() {
        const items = this.dataset.variantIds.split(',').map((id) => ({ id: Number(id), quantity: 1 }));
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.error.hidden = true;

        try {
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message);
          window.location.href = this.dataset.cartUrl;
        } catch (error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
